<template>
  <div style="height: 100%; min-height: 62px" class="d-flex flex-colum align-center" @click="$emit('click')">
    <div>{{ createdAt }}</div>
    <div v-if="createdByShown">{{ createdBy }}</div>
  </div>
</template>

<script>
import moment from 'moment'
import get from 'lodash-es/get'
export default {
  props: { item: Object, createdByShown: Boolean },
  computed: {
    createdAt() {
      const createdAt = get(this.item, 'createdAt')
      if (!createdAt) return '--'
      return moment(createdAt).format('DD/MM/YYYY HH:mm')
    },
    createdBy() {
      const createdByName = get(this.item, 'createdByName')
      if (!createdByName || createdByName !== 'parent') return 'Phụ huynh đăng ký'
      return `Tạo bởi ${createdByName}`
    },
  },
}
</script>
